import UitgevoerdeTaak, {UitgevoerdeTaakDto} from '../prestatie/uitgevoerde-taak';

export class TaakGeschiedenis {

  static deserialize(dto: TaakGeschiedenisDto): TaakGeschiedenis {
    return new TaakGeschiedenis(
      dto.clientId,
      dto.taken.map(taak => UitgevoerdeTaak.deserialize(taak)),
    );
  }

  constructor(
    private clientId: string,
    private taken: Array<UitgevoerdeTaak>,
  ) {
  }

  getClientId(): string {
    return this.clientId;
  }

  getTaken(): Array<UitgevoerdeTaak> {
    return this.taken;
  }

  getLaatsteUitvoeringsDatum(categorieId: string, taakId: string): Date | undefined {
    return this.taken
      .filter(taak => taak.hasCategorieEnTaakId(categorieId, taakId))
      .map(taak => taak.getTijdstip())
      .sort((date2, date1) => date1.getTime() - date2.getTime())[0];
  }
}

export interface TaakGeschiedenisDto {
  clientId: string;
  taken: Array<UitgevoerdeTaakDto>;
}
